<div id="trainingOccurenceQuizAudit">
    <p-dialog
      header="Quiz Attempts"
      [(visible)]="isQuizAuditAnswerOpen"
      [modal]="true"
      [draggable]="false"
      [style]="{ width: '90vw','margin-left': '1em' }"
      [closeOnEscape]="false"
    >
      <app-panel-list [panelList]="trainingQuizAnswerAuditListInput"
      [noResultFound] = "noData">
        <ng-template #templateRef let-data="dataVar">
            <div panel-content class="grid">
                <div class="col-fixed text-left" style="width: 20%">
                <div class="font-semibold mb-1">Date & Time</div>
                <div class="content-wrap">
                    {{ data?.completeDate | date : "dd-MMM-yyyy HH:mm": "UTC"}} {{timeZoneFormat}}
                </div>
                </div>
                <div class="col-fixed text-left" style="width: 20%">
                <div class="font-semibold mb-1">Grade</div>
                <div class="content-wrap">
                    {{ data?.grade }}
                </div>
                </div>
                <div class="col-fixed text-left" style="width: 20%">
                    <div class="font-semibold mb-1">Pass/Fail</div>
                    <div class="content-wrap">
                        {{ data?.passOrFail }}
                    </div>
                </div>
                <div class="col-fixed text-left" style="width:20%">
                    <div class="font-semibold mb-1">Quiz Answers</div>
                    <i class="fas fa-chart-column fa-lg blue-color cursor-pointer" pToolTip="Quiz Answers" (click)="openQuiz(data?.quizResponse, data?.quizQuestions)"></i>
                </div>
                <div class="col-fixed text-left" style="width: 20%">
                <div class="font-semibold mb-1">eSignature</div>
                    <i  class="fa-solid fa-file-signature ml-2 blue-color cursor-pointer" pTooltip="eSignature" (click)="openESignature(data?.eSignature)"></i>   
                </div>
            </div>
        </ng-template>
      </app-panel-list>
    </p-dialog>
    
    <p-dialog *ngIf="isESignatureModalOpen"
      header="eSignature"
      [(visible)]="isESignatureModalOpen"
      [modal]="true"
      [draggable]="false"
      [style]="{ width: '35vw','margin-left': '1em' }"
    >
    <div panel-content class="grid">
      <div class="col-fixed text-left content-padding" style="width: 100%">
    <div class="font-semibold mb-1">User</div>
      <div class="content-wrap">
        {{eSignatureDetails.esignature}}
      </div>
      <div></div><br>
    <div class="font-semibold mb-1">Date & Time  </div>
      <div class="content-wrap">
        {{ eSignatureDetails.esignatureDateTime | date : "dd-MMM-yyyy HH:mm": "UTC"}} {{timeZoneFormat}}
    </div>
    <div></div><br>
    <div class="font-semibold mb-1">Meaning</div>
      <div class="content-wrap">
        {{eSignatureDetails.esignatureMeaning}}
      </div>
    </div>
    </div>
    </p-dialog>
    </div>
    <div *ngIf="isQuizModalOpen">
      <app-training-quiz-answer  [quizData]="quizData" [quizResponse]="quizResponse"
      ></app-training-quiz-answer>
    </div>
